import api from "./Api";
import toast from "react-hot-toast";

export async function register_customer(data) {
    try {
        const response = await api.post('/Customer', data);
        toast.success("Usuario registrado correctamente, ahora puedes iniciar sesión")
        return response.data;
    } catch (error) {
        toast.error(error.response?.data?.error)
    }
}

export async function login(email, password) {
    try {
        const response = await api.post('/Auth/Customer', { email, password });

        // La sesión vive en la cookie HttpOnly cust_token (axios withCredentials).
        // No guardamos el token en localStorage (evita robo de sesión por XSS).
        toast.success("Sesión iniciada correctamente")
        return response.data;
    } catch (error) {
        if (error.response?.data?.code === "ACCOUNT_DELETED") {
            toast.error(error.response.data.error || "Tu cuenta fue eliminada. Regístrate de nuevo para reactivarla.");
        } else {
            toast.error("Credenciales incorrectas");
        }
        throw error;
    }
}

export async function getUser() {
    try {
        const response = await api.get('/Auth/Customer/Me');
        return response.data.user;
    } catch (error) {
        if (error.response?.status === 401) {
            return { status: 401, message: "Usuario no autenticado" };
        }

        return null;
    }
}

export async function logout(user) {
    try {
        await api.post('/Auth/Customer/Logout', user);
        localStorage.removeItem("authToken");
    } catch (error) {
        console.error('Error al cerrar sesión:', error);
    }
}